import { useEffect, useCallback } from "react";
import TagManager from "@sooro-io/react-gtm-module";
//
import { GTM_ID } from "src/config-global";

// ----------------------------------------------------------------------

export default function useGTM() {
    const initGTM = useCallback(() => {
        if (window.gtmDidInit) return;

        window.gtmDidInit = true;

        TagManager.initialize({ gtmId: GTM_ID });
    }, []);

    const initGTMOnEvent = useCallback((event) => {
        initGTM();
        //
        event.currentTarget.removeEventListener(event.type, initGTMOnEvent);
    }, [initGTM]);

    useEffect(() => {
        setTimeout(() => initGTM(), 5000);

        window.addEventListener("mousemove", initGTMOnEvent);
        window.addEventListener("keydown", initGTMOnEvent);
        window.addEventListener("scroll", initGTMOnEvent);
        window.addEventListener("touchstart", initGTMOnEvent);

        return () => {
            window.removeEventListener("mousemove", initGTMOnEvent);
            window.addEventListener("keydown", initGTMOnEvent);
            window.removeEventListener("scroll", initGTMOnEvent);
            window.removeEventListener("touchstart", initGTMOnEvent);
        };
    }, [initGTM, initGTMOnEvent]);
}
